export const DRAWER_WIDTH = 240;

export const APPBAR_MAX_HEIGHT = 80;

// IF YOU ARE IN DEV MODE API_DOMAIN IS SET IN .env
// @ts-ignore
let API_DOMAIN = `${process.env.REACT_APP_API_DOMAIN}`;

// Check if the last index is a /, if not add it:
if (API_DOMAIN.substring(API_DOMAIN.length - 1) !== '/') {
	API_DOMAIN = `${API_DOMAIN}/`;
}

const AUTH_URL = 'auth';

const LOGIN_URL = `${AUTH_URL}/login`; // axios baseURL is ${API_DOMAIN}

const RECOVERY_URL = `${AUTH_URL}/password-recovery`; // axios baseURL is ${API_DOMAIN}

const RECOVERY_CONFIRM_URL = `${AUTH_URL}/password-recovery/confirm`; // axios baseURL is ${API_DOMAIN}

const ME_URL = `${AUTH_URL}/me`;

const FIRST_TIME_URL = `${AUTH_URL}/first-time`;

const USERS_URL = 'users';

const PROFILE_URL = 'profile';

const ADMIN_URL = 'admin';

const CLIENTS_URL = 'clients';

const rowsPerPageOptions = [10, 25, 50, 100, 500, 1000];

const largeRowsPerPageOptions = [10000, 5000, 1000, 500];

const defaultRowsPerPage = 50;

// @ts-ignore
const PANEL_MANUAL_URL = `${process.env.REACT_APP_PANEL_MANUAL_URL}`;
// @ts-ignore
const IT_MANUAL_URL = `${process.env.REACT_APP_IT_MANUAL_URL}`;

const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['es'];

// @ts-ignore
const NODE_ENV = `${process.env.NODE_ENV || ''}`;

const CLIENTS_DELETION_ENABLED =
	// @ts-ignore
	`${process.env.REACT_CLIENTS_DELETION_ENABLED || 'no'}`.toLocaleLowerCase().substring(0, 1) === 'y';

const PLACE_URL = 'place';

const TAG_URL = 'tag';

const EVENT_URL = 'event';

const ARTIST_URL = 'artist';

const FILE_URL = 'file';

const GENRE_URL = 'genre';

const VEHICLE_URL = 'vehicle';

const TENT_OCCUPANCY_URL = 'tent-occupancy';

const PARKING_OCCUPANCY_URL = 'parking-occupancy';

const ACCESS_URL = 'access';

const SYNC_REPORT_URL = 'sync-report';

const ENTRY_URL = 'entry';

const APP_CONFIG = 'config';

const FAQ = 'faq';

const NOTIFICATION = 'notification';

const MERCHANDISING_URL = 'merch';

const MERCHANDISING_CATS_URL = 'merch-category';

const PRODUCTS_URL = 'product';

const ORDERS_URL = 'order';

const INAPP_BASE_URL = 'inapp/';

const PRODUCTS_CATS_URL = 'product-category';

const SHORCUTS_URL = 'shorcuts';

const PRODUCTS_MIXERS_URL = 'product/mixers';

const SECTIONS_URL = 'section';

const SPONSOR_URL = 'sponsor';

const CANDIDATES = 'candidate';

const COMMENTS = 'comments';

const REACT_APP_ENVIRONMENT = `${process.env.REACT_APP_ENVIRONMENT}`;

const WALLET = 'wallet';

const NFC_URL = 'nfc-card';

const soldProductsRowsPerPageOptions = [10, 100, 500, 1000, 5000, 10000];

const defaultSoldProductsRowsPerPage = 100;

export {
	API_DOMAIN,
	AUTH_URL,
	SHORCUTS_URL,
	ME_URL,
	USERS_URL,
	LOGIN_URL,
	FIRST_TIME_URL,
	rowsPerPageOptions,
	largeRowsPerPageOptions,
	defaultRowsPerPage,
	PANEL_MANUAL_URL,
	IT_MANUAL_URL,
	PROFILE_URL,
	SUPPORTED_LANGUAGES,
	ADMIN_URL,
	RECOVERY_URL,
	RECOVERY_CONFIRM_URL,
	NODE_ENV,
	CLIENTS_URL,
	CLIENTS_DELETION_ENABLED,
	PLACE_URL,
	TAG_URL,
	EVENT_URL,
	ARTIST_URL,
	FILE_URL,
	GENRE_URL,
	VEHICLE_URL,
	ACCESS_URL,
	ENTRY_URL,
	APP_CONFIG,
	FAQ,
	NOTIFICATION,
	MERCHANDISING_URL,
	MERCHANDISING_CATS_URL,
	SPONSOR_URL,
	REACT_APP_ENVIRONMENT,
	PRODUCTS_URL,
	ORDERS_URL,
	PRODUCTS_CATS_URL,
	SECTIONS_URL,
	PRODUCTS_MIXERS_URL,
	CANDIDATES,
	COMMENTS,
	TENT_OCCUPANCY_URL,
	PARKING_OCCUPANCY_URL,
	SYNC_REPORT_URL,
	INAPP_BASE_URL,
	WALLET,
	NFC_URL,
	soldProductsRowsPerPageOptions,
	defaultSoldProductsRowsPerPage,
};
